import React, { useState, useContext, useEffect, useMemo, Suspense } from "react";

import { Link, useParams } from "react-router-dom";

import {
  SaveSelfAssessment,
  GetEmployeeAppraisals,
  DraftSaveSelfAssessment,
} from "./PMSService";

import { TostMsg } from "../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

const MyAssessment = () => {
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  const toster = useContext(TostMsg);

  const [isSaving, setIsSaving] = useState(false);

  const [kraList, setKraList] = useState([]);
  const [criteriaQuestions, setCriteriaQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    KpiResponses: [],
    CriteriaAnswers: [],
  });

  const [formErrors, setFormErrors] = useState({
    KpiResponses: {},
    CriteriaAnswers: {},
  });

  const [showSubmitModal, setShowSubmitModal] = useState(false);

  const [isEditMode, setIsEditMode] = useState(false);
  const { guid } = useParams();
  const [appraisalData, setAppraisal] = useState([]);
  const history = useHistory();

  /*
   * =========================================================
   * INITIAL LOAD
   * =========================================================
   */

  useEffect(() => {
    // loadAssessmentData();
    getAppraisalDetail();
  }, [guid]);


  /*
   * =========================================================
   * KPI CHANGE
   * =========================================================
   */

  const handleKpiChange = (kpiId, field, value) => {
    setFormData((prev) => ({
      ...prev,

      KpiResponses: prev.KpiResponses.map((item) =>
        Number(item.KpiSnapshotId) === Number(kpiId)
          ? {
              ...item,
              [field]: value,
            }
          : item,
      ),
    }));

    setFormErrors((prev) => ({
      ...prev,

      KpiResponses: {
        ...prev.KpiResponses,

        [kpiId]: {
          ...prev.KpiResponses?.[kpiId],

          [field]: "",
        },
      },
    }));
  };

  /*
   * =========================================================
   * QUESTION CHANGE
   * =========================================================
   */

  const handleCriteriaChange = (questionId, value) => {
    setFormData((prev) => ({
      ...prev,

      CriteriaAnswers: prev.CriteriaAnswers.map((item) =>
        Number(item.QuestionId) === Number(questionId)
          ? {
              ...item,
              Answer: value,
            }
          : item,
      ),
    }));

    setFormErrors((prev) => ({
      ...prev,

      CriteriaAnswers: {
        ...prev.CriteriaAnswers,

        [questionId]: "",
      },
    }));
  };

  const getAppraisalDetail = async () => {
    try {
      if (!guid) {
        console.error("Assessment GUID not found.");
        return null;
      }

      setLoading(true);

      const params = {
        Guid: guid,
      };

      const response = await GetEmployeeAppraisals(params);

      console.log("APPRAISAL DETAIL RESPONSE:", response);

      const responseRoot = response?.Data ?? response;

      const apiData = responseRoot ?? {};

      console.log("NORMALIZED APPRAISAL DATA:", apiData);

      // ---------------------------------------------------------
      // APPRAISAL HEADER DATA
      // ---------------------------------------------------------
      setAppraisal(apiData);
      setLoading(false);

      const kraList = Array.isArray(apiData?.Kras)
        ? apiData.Kras
        : [];
      // ---------------------------------------------------------
      // QUESTIONS FROM APPRAISAL API
      // ---------------------------------------------------------
      const apiQuestions = Array.isArray(apiData?.Questions)
        ? apiData.Questions
        : [];

      console.log("APPRAISAL QUESTIONS:", apiQuestions);

      // ---------------------------------------------------------
      // NORMALIZE QUESTIONS
      // ---------------------------------------------------------
      const normalizedQuestions = apiQuestions.map((question, index) => ({
        ...question,

        QuestionId:
          question?.QuestionId ??
          question?.QuestionID ??
          question?.Id ??
          index + 1,

        SectionName: question?.SectionName ?? question?.Section ?? "",

        QuestionText:
          question?.QuestionText ??
          question?.Question ??
          question?.Questions ??
          "",

        Weightage: question?.Weightage ?? question?.WeightagePercentage ?? 0,

        // IMPORTANT:
        // API gives EmployeeAnswer, not Answer
        EmployeeAnswer:
          question?.EmployeeAnswer ??
          question?.Answer ??
          question?.Response ??
          "",

        EffectiveComment: question?.EffectiveComment ?? "",

        EffectiveScore: question?.EffectiveScore ?? null,
      }));

      console.log("NORMALIZED QUESTIONS:", normalizedQuestions);

      // THIS WAS MISSING
      setCriteriaQuestions(normalizedQuestions);

      // ---------------------------------------------------------
      // EXISTING KPI RESPONSES
      // ---------------------------------------------------------
     

const apiKras = Array.isArray(apiData?.Kras)
  ? apiData.Kras
  : [];

// Normalize KRA and nested KPI data for the UI
const normalizedKras = apiKras.map((kra, kraIndex) => ({
  ...kra,

  // API: KraSnapshotId, KraTitle
  Id: kra?.KraSnapshotId ?? kraIndex,
  Title: kra?.KraTitle ?? "KRA",
  Description: kra?.Description ?? "",
  TargetDate: kra?.TargetDate ?? "",
  SetByName: kra?.SetByName ?? "",
  Status: kra?.Status ?? "Active",

  // API: Kpis[]
  Kpis: (Array.isArray(kra?.Kpis) ? kra.Kpis : []).map(
    (kpi, kpiIndex) => ({
      ...kpi,

      KpiSnapshotId:
        kpi?.KpiSnapshotId ?? kpi?.Id ?? kpiIndex,

      KraSnapshotId:
        kpi?.KraSnapshotId ?? kra?.KraSnapshotId,

      // API: KpiDescription
      Name:
        kpi?.KpiName ??
        kpi?.KPIName ??
        kpi?.Name ??
        kpi?.KpiDescription ??
        `KPI ${kpiIndex + 1}`,

      Description: kpi?.KpiDescription ?? kpi?.Description ?? "",
      TargetDate: kpi?.TargetDate ?? "",
    })
  ),
}));

setKraList(normalizedKras);

// Build editable KPI responses from nested Kras[].Kpis[]
const normalizedKpiResponses = normalizedKras.flatMap((kra) =>
  kra.Kpis.map((kpi) => ({
    KpiSnapshotId: kpi.KpiSnapshotId,
    KraSnapshotId: kpi.KraSnapshotId,

    CompletionPct: kpi.CompletionPct ?? "",

    // API: EmployeeNarrative
    Narrative:
      kpi.EmployeeNarrative ??
      kpi.Narrative ??
      kpi.Comment ??
      "",
  }))
);



      // ---------------------------------------------------------
      // CRITERIA ANSWERS
      // ---------------------------------------------------------
      // Build CriteriaAnswers directly from Questions
      // because the appraisal API returns EmployeeAnswer
      const normalizedCriteriaAnswers = normalizedQuestions.map((question) => ({
        QuestionId: question.QuestionId,

        Answer: question?.EmployeeAnswer ?? "",
      }));

      console.log("NORMALIZED CRITERIA ANSWERS:", normalizedCriteriaAnswers);

      // ---------------------------------------------------------
      // UPDATE FORM DATA
      // ---------------------------------------------------------
      setFormData((prev) => ({
        ...prev,

        KpiResponses:
          normalizedKpiResponses.length > 0
            ? normalizedKpiResponses
            : (prev?.KpiResponses ?? []),

        CriteriaAnswers:
          normalizedCriteriaAnswers.length > 0
            ? normalizedCriteriaAnswers
            : (prev?.CriteriaAnswers ?? []),
      }));

      return apiData;
    } catch (error) {
      console.error("Get appraisal detail error:", error);

      toster?.current?.error(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          "Failed to load appraisal details.",
      );

    }
    finally{
      setLoading(false);
    }
  };
  /*
   * =========================================================
   * VALIDATION
   * =========================================================
   */

  const validateForm = () => {
    const errors = {
      KpiResponses: {},
      CriteriaAnswers: {},
    };

    let isValid = true;

    /*
     * KPI VALIDATION
     */

    // formData.KpiResponses.forEach(
    //   (item) => {
    //     const kpiId =
    //       item.KpiSnapshotId;

    //     const completion =
    //       item?.CompletionPct;

    //     const narrative =
    //       item?.Narrative?.trim();

    //     if (
    //       completion === "" ||
    //       completion === null ||
    //       completion === undefined
    //     ) {
    //       errors.KpiResponses[
    //         kpiId
    //       ] = {
    //         ...errors.KpiResponses[
    //           kpiId
    //         ],

    //         CompletionPct:
    //           "Completion percentage is required.",
    //       };

    //       isValid = false;
    //     } else if (
    //       Number(completion) < 0 ||
    //       Number(completion) > 100
    //     ) {
    //       errors.KpiResponses[
    //         kpiId
    //       ] = {
    //         ...errors.KpiResponses[
    //           kpiId
    //         ],

    //         CompletionPct:
    //           "Completion percentage must be between 0 and 100.",
    //       };

    //       isValid = false;
    //     }

    //     if (!narrative) {
    //       errors.KpiResponses[
    //         kpiId
    //       ] = {
    //         ...errors.KpiResponses[
    //           kpiId
    //         ],

    //         Narrative:
    //           "Narrative is required.",
    //       };

    //       isValid = false;
    //     } else if (
    //       narrative.length < 10
    //     ) {
    //       errors.KpiResponses[
    //         kpiId
    //       ] = {
    //         ...errors.KpiResponses[
    //           kpiId
    //         ],

    //         Narrative:
    //           "Narrative must contain at least 10 characters.",
    //       };

    //       isValid = false;
    //     }
    //   }
    // );

    /*
     * QUESTIONS VALIDATION
     */

    formData.CriteriaAnswers.forEach((item) => {
      const questionId = item.QuestionId;

      const answer = item?.Answer?.trim();

      if (!answer) {
        errors.CriteriaAnswers[questionId] = "Self evaluation is required.";

        isValid = false;
      } else if (answer.length < 10) {
        errors.CriteriaAnswers[questionId] =
          "Self evaluation must contain at least 10 characters.";

        isValid = false;
      }
    });

    setFormErrors(errors);

    return isValid;
  };

  const handleSaveDraftAssessment = async (isSubmit = false) => {
    // const isValid = validateForm();

    // if (!isValid) {
    //   toster?.current?.error("Please fix the validation errors before saving.");

    //   return;
    // }

    setLoading(true);
    const payload = {
      KpiResponses: formData?.KpiResponses.map((item) => ({
        KpiSnapshotId: Number(item.KpiSnapshotId),

        CompletionPct: Number(item.CompletionPct),

        Narrative: item.Narrative?.trim() || "",
      })),

      CriteriaAnswers: formData.CriteriaAnswers.map((item) => ({
        QuestionId: Number(item.QuestionId),

        Answer: item.Answer?.trim() || "",
      })),
    };

    console.log("SAVE SELF ASSESSMENT PAYLOAD:", payload);

    try {
      setIsSaving(true);

      const response = await DraftSaveSelfAssessment(
        payload,
        appraisalData?.AppraisalId,
      );

      console.log("SAVE RESPONSE:", response);

      if (
        response?.statusCode === 200 ||
        response?.status === 200 ||
        response?.Data
      ) {
        toster?.current?.success("Self assessment draft saved successfully.");

        getAppraisalDetail();
      } else {
        toster?.current?.error(
          response?.message ||
            response?.data?.message ||
            "Unable to save self assessment.",
        );
      }

      setLoading(false);
    } catch (error) {
      console.error("Save self assessment error:", error);

      toster?.current?.error(
        error?.response?.data?.message ||
          "Something went wrong while saving self assessment.",
      );
    } finally {
      setIsSaving(false);
      setLoading(false);
    }
  };

  /*
   * =========================================================
   * SAVE / SUBMIT
   * =========================================================
   */

  const handleSaveAssessment = async (isSubmit = false) => {
    const isValid = validateForm();

    if (!isValid) {
      toster?.current?.error("Please fix the validation errors before saving.");

      return;
    }

    setLoading(true);
    const payload = {
      KpiResponses: formData?.KpiResponses.map((item) => ({
        KpiSnapshotId: Number(item.KpiSnapshotId),

        CompletionPct: Number(item.CompletionPct),

        Narrative: item.Narrative?.trim() || "",
      })),

      CriteriaAnswers: formData.CriteriaAnswers.map((item) => ({
        QuestionId: Number(item.QuestionId),

        Answer: item.Answer?.trim() || "",
      })),
    };

    console.log("SAVE SELF ASSESSMENT PAYLOAD:", payload);

    try {
      setIsSaving(true);

      const response = await SaveSelfAssessment(
        payload,
        appraisalData?.AppraisalId,
      );

      console.log("SAVE RESPONSE:", response);

      if (
        response?.statusCode === 200 ||
        response?.status === 200 ||
        response?.data?.statusCode === 200 ||
        response?.Data
      ) {
        toster?.current?.success(
          // isSubmit
          //   ? "Self assessment submitted successfully."
          //   : 
            isEditMode
              ? "Self assessment updated successfully."
              : "Self assessment submitted successfully.",
        );

        history.push("/Assessment/Employee/Dashboard");

        getAppraisalDetail();

        setIsEditMode(true);

        if (isSubmit) {
          setShowSubmitModal(false);
        }
      } else {
        toster?.current?.error(
          response?.message ||
            response?.data?.message ||
            "Unable to save self assessment.",
        );
      }

      setLoading(false);
    } catch (error) {
      console.error("Save self assessment error:", error);

      toster?.current?.error(
        error?.response?.data?.message ||
          "Something went wrong while saving self assessment.",
      );
    } finally {
      setIsSaving(false);
      setLoading(false);
    }
  };

  const formatPeriod = (from, to) => {
    if (!from || !to) return "-";

    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) {
      return "-";
    }

    return `${fromDate.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    })} – ${toDate.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    })}`;
  };

  /*
   * =========================================================
   * PROGRESS
   * =========================================================
   */

  const totalKpis = useMemo(() => {
    return kraList.reduce((total, kra) => total + (kra?.Kpis?.length || 0), 0);
  }, [kraList]);

  const completedKpis = formData.KpiResponses.filter(
    (item) =>
      item?.CompletionPct !== "" && item?.Narrative?.trim()?.length >= 10,
  ).length;

  const totalQuestions = criteriaQuestions.length;

  const completedQuestions = formData.CriteriaAnswers.filter(
    (item) => item?.Answer?.trim()?.length >= 10,
  ).length;

  const kpiProgress =
    totalKpis > 0 ? Math.round((completedKpis / totalKpis) * 100) : 0;

  const questionProgress =
    totalQuestions > 0
      ? Math.round((completedQuestions / totalQuestions) * 100)
      : 0;

  /*
   * =========================================================
   * RENDER
   * =========================================================
   */

  return (
    <div>
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="og-main">
            {/* =================================================
                HEADER
            ================================================= */}

            <div className="og-page-header">
              <div>
                <div className="og-breadcrumb">
                  <Link
                    to="/Assessment/Employee/Dashboard"
                    style={{
                      color: "#EC4119",
                      textDecoration: "none",
                    }}
                  >
                    Performance
                  </Link>{" "}
                  › Self Assessment
                </div>

                <div className="og-page-title">Self Appraisal</div>

                <div className="og-page-sub">
                  {appraisalData?.CycleTitle} · Review Period:{" "}
                  {formatPeriod(
                    appraisalData?.ReviewPeriodFrom,
                    appraisalData?.ReviewPeriodTo,
                  )}
                </div>
              </div>

              {appraisalData?.CurrentStageId === 1 && (
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                  }}
                >
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={() => handleSaveDraftAssessment(false)}
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Save Draft"}
                  </button>

                  <button
                    type="button"
                    className="btn-og btn-og-primary"
                    onClick={() => {
                      if (!validateForm()) {
                        toster?.current?.error(
                          "Please fix the validation errors before saving.",
                        );

                        return;
                      }

                      setShowSubmitModal(true);
                    }}
                    disabled={isSaving}
                  >
                    Submit for Review
                  </button>
                </div>
              )}
            </div>

            {/* =================================================
                EMPLOYEE / REVIEWER INFORMATION
            ================================================= */}

            <div
              className="og-card"
              style={{
                marginBottom: 9,
                padding: "7px 9px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 17,
                }}
              >
                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <div className="og-label">MANAGER (FIRST REVIEWER)</div>

                  <div className="og-emp-cell">
                    {/* <div
                      className="og-emp-av"
                      style={{
                        background: "#EC4119",
                      }}
                    >
                      {(userDetails?.FullName || "Employee")
                        .split(" ")
                        .map((x) => x[0])
                        .join("")
                        .substring(0, 2)}
                    </div> */}

                    <div
                      
                    >
                      {appraisalData?.FirstReviewerName || "-"}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <div className="og-label">SKIP-LEVEL (SECOND REVIEWER)</div>

                  <div className="og-emp-cell"
                   
                  >
                    {appraisalData?.SecondReviewerName || "-"}
                  </div>
                </div>

                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <div className="og-label">NORMALIZATION ACTOR</div>

                  <div className="og-emp-cell"
                   
                  >
                    {appraisalData?.NormalizationActorName || "-"}
                  </div>
                </div>

                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <div className="og-label">DEADLINE</div>

                  <div className="og-emp-cell"
                   
                  >
                    {appraisalData?.NormalizationDeadline || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 260px",
                gap: 9,
              }}
            >
             <div
  className="accordion"
  id="appraisalAccordion"
>
  {/* =================================================
      KRA SECTION
  ================================================= */}

  <div
    className="og-card accordion-item"
   
  >
    {/* KRA HEADER */}

    <div
      className="og-section-hd"
      id="headingKra"
    >
      <div className="d-flex align-items-center gap-2">
        <div className="og-section-num">
          A
        </div>

        <div className="og-section-title">
          KRA / Goals Assessment
        </div>
      </div>

      <div className="d-flex gap-2 align-items-center">

        <div className="og-section-wt">
          {appraisalData?.KraSectionWeightage}% of final score
        </div>

        <button
          className="btn btn-default btn-sm"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseKra"
          aria-expanded="false"
          aria-controls="collapseKra"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-chevron-down"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </button>

      </div>
    </div>


    {/* KRA COLLAPSE */}

    <div
      id="collapseKra"
      className="accordion-collapse collapse"
      aria-labelledby="headingKra"
      data-bs-parent="#appraisalAccordion"
    >

      <div className="accordion-body p-0">

        {/* INFO */}

        <div
          style={{
            fontSize: 12,
            color: "#8492a6",
            marginBottom: 14,
            padding: 10,
            background: "#fffbeb",
            border: "1px solid #fbd38d",
            borderRadius: 8,
          }}
        >
          <i
            className="fa fa-circle-info"
            style={{
              color: "#d97706",
            }}
          ></i>{" "}
          For each KPI, enter your completion percentage and a brief
          narrative.
        </div>


        {/* KRA LIST */}

        {kraList.length === 0 ? (

          <div
            style={{
              padding: 20,
              textAlign: "center",
              color: "#8492a6",
            }}
          >
            No KRA found.
          </div>

        ) : (

          kraList.map((kra, kraIndex) => (

            <div
              key={kra?.Id || kraIndex}
              style={{
                marginBottom: 20,
                paddingBottom: 16,
                borderBottom: "1px solid #f1f3f7",
              }}
            >

              {/* KRA HEADER */}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: 12,
                }}
              >

                <div>

                  {/* TITLE */}

                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 700,
                      color: "#1a1a2e",
                      marginBottom: 5,
                    }}
                  >
                    {kra?.Title || "KRA"}
                  </div>


                  {/* DESCRIPTION */}

                  {/* <div
                    style={{
                      fontSize: 12.5,
                      color: "#8492a6",
                      lineHeight: 1.5,
                    }}
                  >
                    {kra?.Description ||
                      "No description available."}
                  </div> */}


                  {/* META */}

                  <div
                    style={{
                      display: "flex",
                      gap: 18,
                      marginTop: 8,
                      fontSize: 11.5,
                      color: "#8492a6",
                      flexWrap: "wrap",
                    }}
                  >

                    <span>
                      Target Date:{" "}
                      <strong>
                        {kra?.TargetDate ||
                          "Not specified"}
                      </strong>
                    </span>

                    {/* <span>
                      Set By:{" "}
                      <strong>
                        {kra?.SetByName ||
                          "Not specified"}
                      </strong>
                    </span> */}

                    {/* <span>
                      Status:{" "}
                      <strong>
                        {kra?.Status || "Active"}
                      </strong>
                    </span> */}

                  </div>

                </div>

              </div>


              {/* =================================================
                  KPIs
              ================================================= */}

              {kra?.Kpis?.length > 0 ? (

                kra.Kpis.map((kpi, kpiIndex) => {

                  const kpiId =
                    kpi?.KpiSnapshotId ??
                    kpi?.Id ??
                    kpiIndex;


                  const response =
                    formData.KpiResponses.find(
                      (item) =>
                        Number(
                          item.KpiSnapshotId
                        ) === Number(kpiId)
                    );


                  const error =
                    formErrors?.KpiResponses?.[
                      kpiId
                    ] || {};


                  return (

                    <div
                      className="og-kpi-item"
                      key={kpiId}
                      style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 10,
                        padding: "14px 0",
                      }}
                    >

                      {/* KPI */}

                      <div>

                        <div
                          className="og-kpi-dot"
                          style={{
                            display:
                              "inline-block",
                            marginRight: 6,
                          }}
                        ></div>

                        <span
                          style={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#1a1a2e",
                          }}
                        >
                          {kpi?.Name ||
                            kpi?.KpiName ||
                            kpi?.KPIName ||
                            kpi?.Title ||
                            `KPI ${
                              kpiIndex + 1
                            }`}
                        </span>

                      </div>


                      {/* KPI DESCRIPTION */}

                      {/* {kpi?.Description && (

                        <div
                          style={{
                            fontSize: 12,
                            color: "#8492a6",
                          }}
                        >
                          {kpi.Description}
                        </div>

                      )} */}


                      {/* TARGET */}

                      {kpi?.TargetDate && (

                        <div
                          style={{
                            fontSize: 11.5,
                            color: "#8492a6",
                          }}
                        >
                          Target Date:{" "}
                          {kpi.TargetDate}
                        </div>

                      )}


                      {/* COMPLETION */}

                      <div className="og-pct-wrap">

                        <label
                          className="og-label"
                          style={{
                            margin: 0,
                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          % Completion
                        </label>

                        <input
                          className="og-pct-input"
                          type="number"
                          min="0"
                          max="100"
                          value={
                            response?.CompletionPct ??
                            ""
                          }
                          onChange={(e) => {

                            let value =
                              e.target.value;

                            if (
                              value !== ""
                            ) {

                              value =
                                Math.min(
                                  100,
                                  Math.max(
                                    0,
                                    Number(
                                      value
                                    )
                                  )
                                );

                            }

                            handleKpiChange(
                              kpiId,
                              "CompletionPct",
                              value
                            );

                          }}
                          readOnly
                        />

                        <span
                          style={{
                            fontSize: 13,
                            fontWeight: 700,
                            color: "#8492a6",
                          }}
                        >
                          %
                        </span>

                      </div>


                      {/* COMPLETION ERROR */}

                      {error?.CompletionPct && (

                        <div
                          style={{
                            color: "#e53e3e",
                            fontSize: 11,
                          }}
                        >
                          {
                            error.CompletionPct
                          }
                        </div>

                      )}


                      {/* NARRATIVE */}

                      <div
                        style={{
                          width: "100%",
                        }}
                      >

                        <label className="og-label">
                          Your Narrative
                        </label>

                        <textarea
                          className="og-textarea"
                          style={{
                            minHeight: 64,
                          }}
                          placeholder="Describe your progress..."
                          value={
                            response?.Narrative ||
                            ""
                          }
                          onChange={(e) =>
                            handleKpiChange(
                              kpiId,
                              "Narrative",
                              e.target.value
                            )
                          }
                          readOnly
                        />

                        {error?.Narrative && (

                          <div
                            style={{
                              color:
                                "#e53e3e",
                              fontSize: 11,
                              marginTop: 4,
                            }}
                          >
                            {
                              error.Narrative
                            }
                          </div>

                        )}

                      </div>

                    </div>

                  );

                })

              ) : (

                <div
                  style={{
                    padding: 12,
                    color: "#8492a6",
                    fontSize: 12,
                  }}
                >
                  No KPIs found for this KRA.
                </div>

              )}

            </div>

          ))

        )}

      </div>

    </div>

  </div>


  {/* =================================================
      CURRENT CYCLE EVALUATION
  ================================================= */}

  <div
    className="og-card accordion-item"
    style={{
      marginBottom: 14,
      border: "none",
    }}
  >

    {/* CURRENT CYCLE HEADER */}

    <div
      className="og-section-hd"
      id="headingCriteria"
    >

      <div className="d-flex align-items-center gap-2">

        <div className="og-section-num">
          B
        </div>

        <div className="og-section-title">
          Current Cycle Evaluation
        </div>

      </div>


      <div className="d-flex gap-2 align-items-center">

        <div className="og-section-wt">
          {appraisalData?.CriteriaSectionWeightage}% of final score
        </div>

        <button
          className="btn btn-default btn-sm"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseCriteria"
          aria-expanded="false"
          aria-controls="collapseCriteria"
        >

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-chevron-down"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>

        </button>

      </div>

    </div>


    {/* CURRENT CYCLE COLLAPSE */}

    <div
      id="collapseCriteria"
      className="accordion-collapse collapse"
      aria-labelledby="headingCriteria"
      data-bs-parent="#appraisalAccordion"
    >

      <div className="accordion-body p-0">

        {criteriaQuestions.length === 0 ? (

          <div
            style={{
              padding: 20,
              textAlign: "center",
              color: "#8492a6",
            }}
          >
            No questions found.
          </div>

        ) : (

          criteriaQuestions.map(
            (question, index) => {

              const questionId =
                question?.QuestionId ??
                index;


              const answer =
                formData.CriteriaAnswers.find(
                  (item) =>
                    Number(
                      item.QuestionId
                    ) ===
                    Number(questionId)
                )?.Answer || "";


              const error =
                formErrors?.CriteriaAnswers?.[
                  questionId
                ];


              return (

                <div
                  key={questionId}
                  style={{
                    padding: "14px 0",
                    borderBottom:
                      "1px solid #f1f3f7",
                  }}
                >

                  {/* SECTION + WEIGHTAGE */}

                  <div
                    style={{
                      display: "flex",
                      alignItems:
                        "center",
                      gap: 8,
                      marginBottom: 8,
                    }}
                  >

                    {question?.SectionName && (

                      <span
                        style={{
                          fontSize: 10.5,
                          fontWeight: 700,
                          color: "#8492a6",
                          textTransform:
                            "uppercase",
                          background:
                            "#f1f3f7",
                          padding:
                            "2px 8px",
                          borderRadius: 4,
                        }}
                      >
                        {
                          question.SectionName
                        }
                      </span>

                    )}


                    {question?.Weightage !==
                      undefined && (

                      <span
                        style={{
                          fontSize: 10.5,
                          color: "#EC4119",
                          fontWeight: 600,
                        }}
                      >
                        {
                          question.Weightage
                        }%
                      </span>

                    )}

                  </div>


                  {/* QUESTION */}

                  <div
                    style={{
                      fontSize: 13.5,
                      fontWeight: 600,
                      color: "#1a1a2e",
                      marginBottom: 10,
                    }}
                  >
                    {question?.QuestionText ||
                      `Question ${
                        index + 1
                      }`}
                  </div>


                  {/* SELF EVALUATION */}

                  <label className="og-label">
                    Your Self Evaluation
                  </label>

                  <textarea
                    className="og-textarea"
                    placeholder="Describe your evaluation..."
                    value={answer}
                    onChange={(e) =>
                      handleCriteriaChange(
                        questionId,
                        e.target.value
                      )
                    }
                  />


                  {/* ERROR */}

                  {error && (

                    <div
                      style={{
                        color:
                          "#e53e3e",
                        fontSize: 11,
                        marginTop: 4,
                      }}
                    >
                      {error}
                    </div>

                  )}

                </div>

              );

            }
          )

        )}

      </div>

    </div>

  </div>

</div>



              {/* =================================================
                  RIGHT SIDEBAR
              ================================================= */}

              <div>
                <div
                  className="og-card"
                  style={{
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#8492a6",
                      textTransform: "uppercase",
                      letterSpacing: ".4px",
                      marginBottom: 10,
                    }}
                  >
                    Progress
                  </div>

                  {/* KRA */}

                  <div
                    style={{
                      marginBottom: 8,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: 12,
                        marginBottom: 4,
                      }}
                    >
                      <span>KRA / KPI</span>

                      <span
                        style={{
                          fontWeight: 600,
                        }}
                      >
                        {completedKpis}/{totalKpis}
                      </span>
                    </div>

                    <div className="og-progress">
                      <div
                        className="og-progress-bar"
                        style={{
                          width: `${kpiProgress}%`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* QUESTIONS */}

                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: 12,
                        marginBottom: 4,
                      }}
                    >
                      <span>Current Cycle</span>

                      <span
                        style={{
                          fontWeight: 600,
                        }}
                      >
                        {completedQuestions}/{totalQuestions}
                      </span>
                    </div>

                    <div className="og-progress">
                      <div
                        className="og-progress-bar"
                        style={{
                          width: `${questionProgress}%`,
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* =================================================
                    TIMELINE
                ================================================= */}

                <div className="og-card">
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#8492a6",
                      textTransform: "uppercase",
                      letterSpacing: ".4px",
                      marginBottom: 10,
                    }}
                  >
                    Cycle Timeline
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                      fontSize: 12.5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                      }}
                    >
                      <i
                        className="fa fa-circle-check"
                        style={{
                          color: "#48bb78",
                        }}
                      ></i>

                      <span>Cycle Initiated</span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                      }}
                    >
                      {appraisalData?.CurrentStageId === 1 ? (
                        <i
                          className="fa fa-clock"
                          style={{
                            color: "#d97706",
                          }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-circle-check"
                          style={{
                            color: "#48bb78",
                          }}
                        ></i>
                      )}

                      <span
                        style={{
                          color:
                            appraisalData?.CurrentStageId === 1
                              ? "#d97706"
                              : "",
                        }}
                      >
                        <strong>Self Assessment</strong>
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        opacity: 0.4,
                      }}
                    >
                      {/* <i className="fa fa-circle"></i> */}

                      {appraisalData?.CurrentStageId === 2 ? (
                        <i
                          className="fa fa-clock"
                          style={{
                            color: "#d97706",
                          }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-circle-check"
                          style={{
                            color: "#48bb78",
                          }}
                        ></i>
                      )}

                      <span
                        style={{
                          color:
                            appraisalData?.CurrentStageId === 2
                              ? "#d97706"
                              : "#000000",
                        }}
                      >
                        <strong>Manager Review</strong>
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        opacity: 0.4,
                      }}
                    >
                      {appraisalData?.CurrentStageId === 4 ? (
                        <i
                          className="fa fa-clock"
                          style={{
                            color: "#d97706",
                          }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-circle-check"
                          style={{
                            color: "#48bb78",
                          }}
                        ></i>
                      )}

                      <span
                        style={{
                          color:
                            appraisalData?.CurrentStageId === 4
                              ? "#d97706"
                              : "#000000",
                        }}
                      >
                        <strong>Normalization</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* =================================================
                SUBMIT MODAL
            ================================================= */}

            {showSubmitModal && (
              <div
                className={`og-modal-overlay ${showSubmitModal ? "open" : ""}`}
              >
                <div className="og-modal">
                  <div className="og-modal-header">
                    <div className="og-modal-title">
                      <i
                        className="fa fa-paper-plane"
                        style={{
                          color: "#EC4119",
                        }}
                      ></i>{" "}
                      Submit Self Appraisal
                    </div>

                    <button
                      className="og-modal-close"
                      onClick={() => setShowSubmitModal(false)}
                    >
                      <i className="fa fa-times"></i>
                    </button>
                  </div>

                  <div className="modal-body">
                    <div
                      style={{
                        textAlign: "center",
                        padding: "10px 0 16px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 42,
                          marginBottom: 10,
                        }}
                      >
                        📋
                      </div>

                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#1a1a2e",
                          marginBottom: 6,
                        }}
                      >
                        Ready to submit your self appraisal?
                      </div>

                      <div
                        style={{
                          fontSize: 13,
                          color: "#8492a6",
                        }}
                      >
                        Once submitted, you cannot edit until your manager sends
                        it back.
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn-og btn-og-secondary"
                      onClick={() => setShowSubmitModal(false)}
                    >
                      Review Again
                    </button>

                    <button
                      className="btn-og btn-og-primary"
                      onClick={() => handleSaveAssessment(true)}
                      disabled={isSaving}
                    >
                      <i className="fa fa-paper-plane"></i>{" "}
                      {isSaving ? "Submitting..." : "Submit for Review"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default MyAssessment;
